import { Component, Input, OnInit } from '@angular/core';
import { Sccs1ConversationType } from '../../../../samwebDescription/samwin/Sccs1ConversationType';
import _ from 'lodash';
import { faAlarmClock } from '@fortawesome/pro-duotone-svg-icons';
import { ConversationStatus } from '../../../../samwebDescription/samwin/ConversationStatus';
import { IciFlags } from '../../../../../generated/signalR/ici-flags';
import { IciVisualizeType } from '../../../../samwebDescription/samwin/IciVisualizeType';

@Component({
   selector: 'samweb-conversation-type',
   templateUrl: './conversation-type.component.html',
   styleUrls: ['./conversation-type.component.scss'],
})
export class ConversationTypeComponent implements OnInit {
   public readonly solidFlag = faAlarmClock;

   constructor() {
      this.ConversationType = Sccs1ConversationType.Unknown;
      this.ConversationStatus = ConversationStatus.UNKNOWN;
   }

   public ConversationType: Sccs1ConversationType;
   public ConversationStatus: ConversationStatus;
   public conversationIciVisualization: IciVisualizeType[];

   @Input()
   set conversationIci(ici: IciFlags) {
      this.conversationIciVisualization = IciVisualizeType.getAllIciVisualizationTypesForIci(ici);
   }

   @Input()
   set conversationTypeAsString(name: string) {
      this.ConversationType = Sccs1ConversationType.valueByName(name);
      if (_.isNil(this.ConversationType)) {
         this.ConversationType = Sccs1ConversationType.Unknown;
      }
   }

   @Input()
   set conversationStatusTypeAsSamwinValue(samwinValue: number) {
      this.ConversationStatus = ConversationStatus.valueBySamwinValue(samwinValue);
   }

   @Input()
   set conversationTypeAsSamwinValue(samwinValue: number) {
      this.ConversationType = Sccs1ConversationType.valueBySamwinValue(samwinValue);
      if (_.isNil(this.ConversationType)) {
         this.ConversationType = Sccs1ConversationType.Unknown;
      }
   }

   ngOnInit() {}
}
